import { render } from "./TheFooter.vue?vue&type=template&id=547fbfb2&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=547fbfb2&scoped=true&lang=css"

import exportComponent from "/Users/zellwegv/repos-work/ce-365-simple-curve/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547fbfb2"]])

export default __exports__